export default "__VITE_ASSET__QTL9thaE__"